import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SnotifyService } from 'ng-snotify';
import { environment } from '../../environments/environment';
import { Cylinder_Size } from '../models/cylinder_Size';

@Injectable()
export class CylinderSizeService {
  constructor(private http: HttpClient, private snotifyService: SnotifyService) { }
  
  public getAll(): Promise<Cylinder_Size[]> {
    const headers = {
      'Content-Type': 'application/json',
    };
    return new Promise((resolve, reject) => {
      this.http.get<Cylinder_Size[]>(environment.apiUrl + 'cylindersize/getall', { headers: headers }).subscribe(data => {
        resolve(data);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

}
